// src/pages/BusinessHours.jsx
// Rediseño visual aplicado 2026-05-13. Lógica preservada 1:1.
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../services/api';


const Icon = ({ children, size = 16, stroke = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={stroke}
         strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {children}
    </svg>
);
const I = {
    clock: <Icon size={14}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></Icon>,
    check: <Icon size={14}><path d="M20 6 9 17l-5-5" /></Icon>,
    info:  <Icon size={14}><circle cx="12" cy="12" r="9" /><path d="M12 16v-4M12 8h.01" /></Icon>,
};

const DOW_LABELS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

function hydrate(weekly) {
    const map = new Map((weekly || []).map(d => [d.dow, d]));
    return [0, 1, 2, 3, 4, 5, 6].map(dow => map.get(dow) || { dow, active: false, start: '09:00', end: '19:00' });
}


const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
.bh-root {
    --bh-accent: var(--brand-700, #0a4aa8);
    --bh-accent-hover: var(--brand-800, #07357f);
    --bh-accent-ring: rgba(10, 74, 168, .12);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    max-width: 720px; margin: 0 auto; padding: 24px 20px 60px;
    color: var(--c-text-1);
}
.bh-root * { box-sizing: border-box; }
.bh-title { font-size: 24px; font-weight: 700; margin: 0 0 4px; letter-spacing: -0.01em; }
.bh-subtitle { color: var(--c-text-3); font-size: 13.5px; margin: 0 0 22px; line-height: 1.5; }

.bh-card {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 14px; padding: 22px 26px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04), 0 2px 8px rgba(15,23,42,.04);
}
.bh-label { font-size: 13px; font-weight: 600; color: var(--c-text-2); margin: 0 0 8px; display: block; }
.bh-select, .bh-input {
    width: 100%; padding: 9px 12px; font-size: 14px;
    border: 1px solid var(--c-border); border-radius: 8px;
    background: var(--c-input-bg); color: var(--c-text-1);
    font-family: inherit; outline: none;
    transition: border-color .15s, box-shadow .15s;
}
.bh-select:focus, .bh-input:focus { border-color: var(--bh-accent); box-shadow: 0 0 0 3px var(--bh-accent-ring); }

.bh-section { margin-bottom: 22px; }
.bh-section:last-child { margin-bottom: 0; }

.bh-week-row {
    display: grid; grid-template-columns: 130px 1fr 18px 1fr;
    gap: 10px; align-items: center;
    padding: 7px 0;
}
.bh-week-day {
    display: flex; align-items: center; gap: 10px;
    font-size: 13.5px; font-weight: 600; color: var(--c-text-1);
}
.bh-week-sep { color: var(--c-text-4); font-size: 12px; text-align: center; }
.bh-time {
    padding: 7px 10px; font-size: 13px;
    border: 1px solid var(--c-border); border-radius: 7px;
    background: var(--c-input-bg); color: var(--c-text-1);
    font-family: inherit; outline: none;
    transition: border-color .15s, box-shadow .15s;
}
.bh-time:focus { border-color: var(--bh-accent); box-shadow: 0 0 0 3px var(--bh-accent-ring); }
.bh-time:disabled { opacity: 0.5; }

.bh-switch { position: relative; display: inline-block; width: 38px; height: 22px; flex-shrink: 0; cursor: pointer; }
.bh-switch input { opacity: 0; width: 0; height: 0; }
.bh-switch-slider {
    position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;
    background: var(--c-border); border-radius: 22px; transition: background .2s;
}
.bh-switch-slider::before {
    position: absolute; content: ''; height: 16px; width: 16px; left: 3px; bottom: 3px;
    background: #fff; border-radius: 50%; transition: transform .2s;
    box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.bh-switch input:checked + .bh-switch-slider { background: var(--bh-accent); }
.bh-switch input:checked + .bh-switch-slider::before { transform: translateX(16px); }

.bh-actions { display: flex; justify-content: flex-end; margin-top: 22px; }
.bh-btn {
    display: inline-flex; align-items: center; gap: 6px;
    border: 1px solid transparent; border-radius: 8px;
    padding: 9px 18px; font-size: 13.5px; font-weight: 600;
    cursor: pointer; font-family: inherit;
    transition: all .15s;
}
.bh-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.bh-btn-primary { background: var(--bh-accent); color: #fff; border-color: var(--bh-accent); box-shadow: 0 1px 3px rgba(10,74,168,.25); }
.bh-btn-primary:hover:not(:disabled) { background: var(--bh-accent-hover); border-color: var(--bh-accent-hover); transform: translateY(-1px); }

.bh-hint {
    margin-top: 14px; font-size: 12px; color: var(--c-text-4);
    display: flex; gap: 6px; align-items: flex-start;
}

@media (max-width: 540px) {
    .bh-week-row { grid-template-columns: 1fr; gap: 6px; }
    .bh-week-sep { display: none; }
}
`;


export default function BusinessHours() {
    const [loading,  setLoading]  = useState(true);
    const [saving,   setSaving]   = useState(false);
    const [timezone, setTimezone] = useState('America/Mexico_City');
    const [weekly,   setWeekly]   = useState(hydrate([]));

    useEffect(() => {
        api.get('/business-hours')
            .then(res => {
                setTimezone(res.data.timezone || 'America/Mexico_City');
                setWeekly(hydrate(res.data.weekly));
            })
            .catch(() => toast.error('No se pudo cargar el horario laboral'))
            .finally(() => setLoading(false));
    }, []);

    const updateDay = (dow, patch) => {
        setWeekly(prev => prev.map(d => d.dow === dow ? { ...d, ...patch } : d));
    };

    const handleSave = async () => {
        const bad = weekly.find(d => d.active && d.end <= d.start);
        if (bad) { toast.warn(`${DOW_LABELS[bad.dow]}: la hora de fin debe ser mayor que la de inicio`); return; }
        setSaving(true);
        try {
            const { data } = await api.put('/business-hours', { timezone, weekly });
            setWeekly(hydrate(data.weekly));
            toast.success('Horario laboral actualizado');
        } catch (err) {
            toast.error(err.response?.data?.error || 'Error al guardar');
        } finally { setSaving(false); }
    };

    if (loading) {
        return (
            <>
                <style>{CSS}</style>
                <div className="bh-root">
                    <div style={{ textAlign: 'center', padding: 60 }}><Spinner animation="border" variant="primary" /></div>
                </div>
            </>
        );
    }

    return (
        <>
            <style>{CSS}</style>
            <div className="bh-root">
                <h1 className="bh-title">Horario laboral (SLA)</h1>
                <p className="bh-subtitle">
                    El SLA avanza solo durante estas horas. Fuera del horario (noches, feriados, días off),
                    el reloj se pausa y continúa al abrir el siguiente día laboral.
                </p>

                <div className="bh-card">
                    <div className="bh-section">
                        <label className="bh-label">Zona horaria</label>
                        <select className="bh-select" value={timezone} onChange={e => setTimezone(e.target.value)}>
                            <option value="America/Mexico_City">CDMX (America/Mexico_City)</option>
                            <option value="America/Monterrey">Monterrey (America/Monterrey)</option>
                            <option value="America/Cancun">Cancún (America/Cancun)</option>
                            <option value="America/Tijuana">Tijuana (America/Tijuana)</option>
                            <option value="America/Santo_Domingo">Santo Domingo</option>
                        </select>
                    </div>

                    <div className="bh-section">
                        <label className="bh-label" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {I.clock} Horario semanal
                        </label>
                        {weekly.map(d => (
                            <div key={d.dow} className="bh-week-row">
                                <div className="bh-week-day">
                                    <label className="bh-switch">
                                        <input type="checkbox" checked={d.active} onChange={e => updateDay(d.dow, { active: e.target.checked })} />
                                        <span className="bh-switch-slider" />
                                    </label>
                                    {DOW_LABELS[d.dow]}
                                </div>
                                <input type="time" className="bh-time" value={d.start} disabled={!d.active}
                                    onChange={e => updateDay(d.dow, { start: e.target.value })} />
                                <span className="bh-week-sep">a</span>
                                <input type="time" className="bh-time" value={d.end} disabled={!d.active}
                                    onChange={e => updateDay(d.dow, { end: e.target.value })} />
                            </div>
                        ))}
                    </div>

                    <div className="bh-actions">
                        <button type="button" className="bh-btn bh-btn-primary" onClick={handleSave} disabled={saving}>
                            {saving ? <Spinner size="sm" animation="border" /> : <>{I.check} Guardar horario</>}
                        </button>
                    </div>
                </div>

                <p className="bh-hint">
                    {I.info}
                    Los cambios aplican a tickets nuevos. Los tickets existentes conservan el <code>dueAt</code> con el que fueron creados.
                </p>
            </div>
        </>
    );
}
